import { TaxcardManualEditController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Shows a UI for editing a manual taxcard.
 * Typically, this is only used for adding a new tacard: You should not edit existing taxcards except in very limited scenarios (admin/pro).
 * @example
 * ```html
 * <salaxy-taxcard-manual-edit ng-ref="$edit" current="$ctrl.item"></salaxy-taxcard-manual-edit>
 * <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-disabled="!$edit.isFormValid" sxy-text="SALAXY.UI_Terms.save"></button>
 * ```
 */
export class TaxcardManualEdit extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /** The taxcard that is being edited */
    current: "<",
  };

  /** Uses the ODataQueryController */
  public controller = TaxcardManualEditController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/worker/taxcard/TaxcardManualEdit.html";

}
